// Description excerpt: the product description
// (sections/section-product-description.liquid) and the collection description
// (sections/collection-description.liquid).
//
// The description is cut to the section's "Excerpt height" with a fade and a
// "Czytaj więcej" button that expands it in place ("Zwiń" cuts it again).
// A description that is not much taller than the excerpt is shown in full
// without the button, as hiding a couple of lines behind it helps nobody.

// Less hidden text than this and the whole description is shown.
const DESCRIPTION_EXCERPT_MIN_HIDDEN = 80;

if (!customElements.get('description-excerpt')) {
  customElements.define(
    'description-excerpt',
    class DescriptionExcerpt extends HTMLElement {
      connectedCallback() {
        this.content = this.querySelector('.description-excerpt__content');
        this.button = this.querySelector('.description-excerpt__toggle');
        this.buttonText = this.querySelector('.description-excerpt__toggle-text');

        this.button.addEventListener('click', () => this.setExpanded(!this.expanded));

        this.classList.add('description-excerpt--collapsed');
        this.update();
        // Images in the description can make it taller once they load.
        window.addEventListener('load', () => this.update(), { once: true });
      }

      // Shows the button only while enough of the description is hidden.
      update() {
        if (this.expanded) return;

        this.classList.add('description-excerpt--collapsed');
        const hidden = this.content.scrollHeight - this.content.clientHeight;
        const needsExcerpt = hidden > DESCRIPTION_EXCERPT_MIN_HIDDEN;

        this.classList.toggle('description-excerpt--collapsed', needsExcerpt);
        this.button.hidden = !needsExcerpt;
      }

      setExpanded(expanded) {
        this.expanded = expanded;
        this.classList.toggle('description-excerpt--collapsed', !expanded);
        this.button.setAttribute('aria-expanded', expanded);
        this.buttonText.textContent = expanded ? this.dataset.less : this.dataset.more;

        // After collapsing a long description, the reader may be far below it.
        if (!expanded && this.getBoundingClientRect().top < 0) {
          this.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }
  );
}
